import { Link } from 'react-router-dom';

const logoUrl = 'https://storage.helloreaddy.io/project_files/a55b3f6a-c462-4da0-8e74-cf71c31de733/a6bd3919-f5da-42c7-bbed-5fa948e855d4_compressed_logo-RD-V2.webp';

export default function Footer() {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-8">
        <div className="flex items-center justify-center gap-4 md:gap-6 mb-3">
          <div className="flex-1 h-px bg-gradient-to-l from-white/60 to-transparent"></div>
          <img
            src={logoUrl}
            alt="Romuald Roudart"
            className="w-20 h-20 md:w-24 md:h-24 object-contain"
          />
          <div className="flex-1 h-px bg-gradient-to-r from-white/60 to-transparent"></div>
        </div>

        <div className="mt-2 pt-2 flex flex-col items-center gap-1 text-xs text-white/60">
          <p>© {new Date().getFullYear()} Romuald Designer. Tous droits réservés.</p>
          <p className="font-bold">Développement Web : BS Webdesign</p>
          <div className="flex items-center gap-2">
            <Link to="/mentions-legales" className="hover:text-white cursor-pointer">Mentions légales</Link>
            <span className="text-white/30">|</span>
            <Link to="/politique-confidentialite" className="hover:text-white cursor-pointer">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}